import React, { useState } from 'react';
import './App.css';
import { HashRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Board from './components/Board';
import Leaderboard from './components/Leaderboard';
import LEVELS from './levels';
import GameReplay from './components/GameReplay';
import TEST_LEVELS from './test_levels';
import LandingPage from './components/LandingPage';
import About from './components/About';
import PlayerProfile from './components/PlayerProfile';
import { useSearchParams } from 'react-router-dom';

function AppContent() {
  const [level, setLevel] = useState(LEVELS.LEVEL_1); // Set initial level
  const [twitterUser, setTwitterUser] = useState(null);
  const [boardKey, setBoardKey] = React.useState(Date.now());
  const [searchParams] = useSearchParams();
  const gamePlayUUID = searchParams.get('gamePlayUUID');
  const reloadBoardKey = () => {
    setBoardKey(Date.now());
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage twitterUser={twitterUser} setTwitterUser={setTwitterUser} />} />
        <Route path="/level/1" element={<Board config={LEVELS.LEVEL_1} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/level/2" element={<Board config={LEVELS.LEVEL_2} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/level/3" element={<Board config={LEVELS.LEVEL_3} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/kids" element={<Board config={LEVELS.LEVEL_4} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/level/4" element={<Board config={LEVELS.LEVEL_4} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/level/5" element={<Board config={LEVELS.LEVEL_5} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/pixelcrush" element={<Board config={LEVELS.LEVEL_5} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/level/6" element={<Board config={TEST_LEVELS.TEST_LEVEL_5} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/tinydinos" element={<Board config={LEVELS.LEVEL_7} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/testlevel/1" element={<Board config={TEST_LEVELS.TEST_LEVEL_1} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/testlevel/2" element={<Board config={TEST_LEVELS.TEST_LEVEL_2} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/testlevel/3" element={<Board config={TEST_LEVELS.TEST_LEVEL_3} key={boardKey} reloadBoardKey={reloadBoardKey} twitterUser={twitterUser}/>} />
        <Route path="/leaderboard" element={<Leaderboard twitterUser={twitterUser}/>} />
        <Route path="/player" element={<PlayerProfile />} />
        <Route path="/gameReplay" element={<GameReplay gamePlayUUID={gamePlayUUID} />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
